module.exports = __webpack_public_path__ + "img/yj_6.a636cfb4.png";